<template>
<div class="orders">
  <breadcrumb :items="[{ text: (isA('client') ? 'Meus pedidos' : 'Pedidos'), active: true }]" />
  <h4 class="card-title ">Pedidos em aberto</h4>
  <div class="text-right filters" v-if="isAdmin || isManager">
    Filtrar por:
    <b-dropdown :text="filters.supplier ? suppliers.find(s => s._id == filters.supplier).name : 'Fornecedor'" variant="outline-default" class="mb-3" size="sm">
      <b-dropdown-item @click="filters.supplier = null; applyFilters()">Todos os fornecedores</b-dropdown-item>
      <b-dropdown-item v-for="(supplier, index) in suppliers" :key="index" @click="filters.supplier = supplier._id; applyFilters()">{{supplier.name}}</b-dropdown-item>
    </b-dropdown>
    <b-dropdown :text="filters.organization ? organizations.find(s => s._id == filters.organization).name : 'Rede'" variant="outline-default" class="mb-3" size="sm" v-if="isAdmin">
      <b-dropdown-item @click="filters.organization = null; applyFilters()">Todas as redes</b-dropdown-item>
      <b-dropdown-item v-for="(organization, index) in organizations" :key="index" @click="filters.organization = organization._id; applyFilters()">{{organization.name}}</b-dropdown-item>
    </b-dropdown>
  </div>
  <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
  <loading :loading="!current_orders && !error" msg="Carregando lista de pedidos" />
  <no-item :list="current_orders" />
  <table class="table b-table b-table-stacked-lg" v-if="current_orders && current_orders.length">
    <thead>
      <tr>
        <th>Código</th>
        <th v-if="!isA('client')">Cliente</th>
        <th>Data</th>
        <th>Qtd</th>
        <th>Total</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(order, index) in current_orders" :key="index">
        <td>
          <router-link :to="'/pedido/'+order._id">
            Pedido #{{order.code}}
          </router-link>
        </td>
        <td v-if="!isA('client')">
          {{ order.name }}
        </td>
        <td>
          <small>{{order.createdAt | data}}</small>
        </td>
        <td>
          {{order.items.length}}
        </td>
        <td>
          {{orderTotal(order) | moeda}}
        </td>
        <td>
          <span v-if="order.status && (typeof order.status) == 'number'" class="badge order-status" :class="{'badge-primary': order.status == 0, 'badge-warning': (order.status > 0 && order.status < 100), 'badge-success': (order.status >= 100)}">{{parseInt(order.status)}}%</span>
          <span v-else class="badge badge-primary order-status">0%</span>
        </td>
      </tr>
    </tbody>
  </table>
  <br>
  <p class="text-center" v-if="finished_orders && finished_orders.length">
    <button type="button" @click="show_finished = !show_finished" class="btn btn-default">{{show_finished ? 'Esconder' : 'Exibir'}} pedidos concluídos/cancelados</button>
  </p>
  <table class="table b-table b-table-stacked-lg" v-if="show_finished && finished_orders && finished_orders.length">
    <thead>
      <tr>
        <th>Código</th>
        <th>Cliente</th>
        <th>Data</th>
        <th>Items</th>
        <th>Total</th>
        <th>Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(order, index) in finished_orders" :key="index">
        <td>
          <router-link :to="'/pedido/'+order._id">
            Pedido #{{order.code}}
          </router-link>
        </td>
        <td>
          {{ order.name }}
        </td>
        <td>
          <small>{{order.createdAt | data}}</small>
        </td>
        <td>
          {{order.items.length}}
        </td>
        <td>
          {{orderTotal(order) | moeda}}
        </td>
        <td>
          <div v-if="order.status >= 100 && order.items.length == order.items.filter(i => (i.status == 'canceled')).length">
            <span class="badge badge-danger">Cancelado</span>
            <div v-if="isAdmin">
              <a @click="remove(order._id)" class="btn btn-sm btn-secondary btn-block" title="Excluír">
                <i class="fa fa-close"></i>
              </a>
            </div>
          </div>
          <div v-else>
            <span v-if="order.status && (typeof order.status) == 'number'" class="badge order-status" :class="{'badge-primary': order.status == 0, 'badge-warning': (order.status > 0 && order.status < 100), 'badge-success': (order.status >= 100)}">{{parseInt(order.status)}}%</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'

export default {

  name: 'Orders',
  data() {
    return {
      filtered_orders: null,
      current_orders: null,
      finished_orders: null,
      orders: null,
      suppliers: null,
      organizations: null,
      show_finished: false,
      filters: {
        supplier: null,
        organization: null
      }
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      axios.get('orders').then(response => {
        this.orders = response.data
        var suppliers = {}
        var organizations = {}
        this.orders.forEach(order => {
          order.items.forEach(item => {
            if (item.offer && item.offer.supplier) {
              suppliers[item.offer.supplier._id] = item.offer.supplier
            }
            if (item.offer && item.offer.organization) {
              organizations[item.offer.organization._id] = item.offer.organization
            }
          })
        })

        this.suppliers = Object.values(suppliers)
        this.organizations = Object.values(organizations)
        this.applyFilters()
      }).catch(this.showError)
    },
    orderTotal(order) {
      var total = order.items.filter(i => (i.status != 'canceled')).reduce((a, b) => {
        return a + b.total
      }, 0)
      if (order.shipping_price) {
        total += order.shipping_price
      }
      return total
    },
    changeStatus(index) {
      axios.put('orders/'+this.orders[index]._id, {status: this.orders[index].status}).then(response => {
        if (response.data) {
          this.notify("Status atualizado com sucesso!")
        }
      }).catch(this.showError)
    },
    applyFilters() {
      this.filtered_orders = this.orders
      if (this.filters.supplier) {
        this.filtered_orders = this.filtered_orders.filter(order => {
          return order.items.find(item => {
            return item.offer.supplier._id == this.filters.supplier
          })
        })
      }
      if (this.filters.organization) {
        this.filtered_orders = this.filtered_orders.filter(order => {
          return order.items.find(item => {
            return item.offer.organization._id == this.filters.organization
          })
        })
      }

      this.current_orders = this.filtered_orders.filter(order => {
        return !order.status || order.status < 100
      })
      this.finished_orders = this.filtered_orders.filter(order => {
        return order.status >= 100
      })
    },
    remove(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios.delete('orders/' + id).then(() => {
          this.list()
        }).catch(this.showError)
      }
    }
  },
  components: {
    Loading,
    NoItem,
  }
};
</script>
<style lang="sass" scoped>
  .order-status
    width: 100%
    background-size: 20%
</style>
